import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const pageSections: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_CMS_API}/singletons/get/PageSections?token=${process.env.REACT_APP_CMS_TOKEN}`
  ),
};

export default pageSections;
